import validator from './validator.js'

export default {
  request: {
    error: 'ohhhh，出错了：',
    permissionError: {
      title: '提示',
    },
    codeMessage: {
      message1: '未登录或 token 失效',
      message2: '抱歉，权限不足',
      message3: '未知错误，请稍后再试',
    },
    loginBox: {
      title: '确定登出',
      confirmButtonText: '重新登录',
    },
    networkError: '网络异常，请稍后重试！',
  },
  publish: {
    text: '发布',
    fail: '发布失败',
    success: '发布成功',
  },
  push: {
    text: '推送',
    fail: '推送失败',
    success: '推送成功',
  },
  download: {
    text: '下载',
    fail: '下载失败',
    success: '下载成功',
  },
  submitButtonText: '提交',
  confirmButtonText: '确定',
  cancelButtonText: '取消',
  deleteTips: '你确定要删除吗？',
  form: {
    search: '搜索',
  },
  creativeType: {
    image: '图片',
    video: '视频',
    endcard: '动态endcard',
    interactiveVideo: '交互视频',
    panorama: '全景endcard',
  },

  validator,
}
